export { colorLegend as legacyColorLegendTheme } from './color-legend';
export { sizeLegend as legacySizeLegendTheme } from './size-legend';
